import { sum, RgCreate, DefaultTechnicalSpace, DefaultModule } from "@project-rouge/rg-core";
import { Vector3toV3, applyTransform, getPivotRaw, distanceToLine, rotateAroundY, getPolySizeAndPos, applyInverseTransform, ResizeRgObj, getLocalCorners, getBoundaries } from "@project-rouge/rg-three";
import { createTechSpaceRooms } from "./index61.js";
import { getCorridorCorners } from "./index153.js";
function createModularTechSpace({ space, includes, dataset, levelId }, modules) {
  let sizeX = 0;
  let sizeY = 0;
  let sizeZ = 0;
  const corners = [];
  const midPivots = [];
  for (const moduleData of modules) {
    midPivots.push(Vector3toV3(applyTransform(getPivotRaw([0.5, 0, 1], moduleData.module), moduleData.apartment)));
    const { start: start2, end: end2 } = getCorridorCorners(moduleData.module, moduleData.apartment);
    corners.push(start2, end2);
  }
  corners.sort((a, b) => a[0] - b[0] + (a[2] - b[2]));
  const start = corners[0];
  const end = corners[corners.length - 1];
  const mid = [(start[0] + end[0]) / 2, start[1], (start[2] + end[2]) / 2];
  sizeX = modules.map((m) => m.module.size[0]).reduce(sum);
  sizeY = Math.max(...modules.map((m) => m.module.size[1]));
  sizeZ = Math.max(...modules.map((m) => m.module.size[2]));
  const anchor = [0.5, 0, Math.max(...midPivots.map((p) => distanceToLine(p, [start, end]).distance / sizeZ))];
  const angle = (modules[0].apartment.rot[1] + 180) % 360;
  const poly = rotateAroundY(getTechSpaceBoundary(modules), mid, angle);
  const { pos } = getPolySizeAndPos(poly, anchor, mid[1], sizeY);
  const localPoly = poly.map((p) => [p[0] - pos[0], p[1] - pos[1], p[2] - pos[2]]);
  const exampleApt = modules[0].apartment;
  const fromRules = {
    data: {
      level: 0,
      levelId,
      muscleID: exampleApt.data.muscleID,
      instance: space,
      polygon: localPoly
    },
    name: space.name
  };
  const techSpace = RgCreate({
    ...DefaultTechnicalSpace,
    ...fromRules,
    name: space.name,
    size: [sizeX, sizeY, sizeZ],
    anchor,
    pos,
    rot: [0, angle, 0],
    parent: exampleApt.parent,
    children: []
  }, dataset.rvData);
  for (const { module, apartment } of modules) {
    const modulePos = applyInverseTransform(Vector3toV3(applyTransform(module.pos, apartment)), techSpace);
    let newModule = RgCreate({
      ...DefaultModule,
      pos: modulePos,
      size: module.size.slice(),
      anchor: module.anchor.slice(),
      parent: techSpace,
      color: "#feffa3"
    }, dataset.rvData);
    newModule = ResizeRgObj({ rgObj: newModule, useCache: false });
    techSpace.children.push(newModule);
  }
  createTechSpaceRooms(techSpace, dataset, includes);
  return techSpace;
}
function getTechSpaceBoundary(modules) {
  const quads = [];
  for (const { module, apartment } of modules) {
    const quad = getLocalCorners(module).map((c) => applyTransform(c, apartment)).map(Vector3toV3);
    quads.push(quad.map((p) => [p[0], 0, p[2]]));
  }
  return getBoundaries(quads, 0.015, 0, true)[0].map(Vector3toV3);
}
export {
  createModularTechSpace
};
//# sourceMappingURL=index137.js.map
